import { render } from "./AddKubernetesSupportedVersion.vue?vue&type=template&id=594c5848&scoped=true"
import script from "./AddKubernetesSupportedVersion.vue?vue&type=script&lang=js"
export * from "./AddKubernetesSupportedVersion.vue?vue&type=script&lang=js"

import "./AddKubernetesSupportedVersion.vue?vue&type=style&index=0&id=594c5848&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594c5848"]])

export default __exports__